// extracted by mini-css-extract-plugin
module.exports = {"emailTakenContainer":"SignupUserForm_emailTakenContainer__wvzyo","nameRow":"SignupUserForm_nameRow__pc_SA"};